// import SimpleCrypto from "simple-crypto-js";
// const secretKey = "Y#M05p6rU"
// const simpleCrypto = new SimpleCrypto(secretKey);
// export const ENCRYPT = (text) => simpleCrypto.encrypt(text);
// export const DECRYPT = (text) => simpleCrypto.decrypt(text);
import moment from 'moment';

import InputBox from './UI/InputBox/InputBox';
import SelectBox from './UI/SelectBox/SelectBox';
import MultiSelectBox from './UI/MultiSelectBox/MultiSelectBox';
import CheckBox from './UI/CheckBox/CheckBox';
import RadioBox from './UI/RadioBox/RadioBox';
import TextareaBox from './UI/TextareaBox/TextareaBox';
import DatePickerBox from './UI/DatePickerBox/DatePickerBox';
import ContainerBox from './UI/ContainerBox/ContainerBox';
import FileUploadBox from './UI/FileUploadBox/FileUploadBox';


import React from 'react';
import { Button } from 'primereact/button';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';


export const getNoOfDaysOptions = (start, end) => {
    let options = [];
    for (let num = start; num <= end; num++) {
        options.push({ label: num, value: num });
    }
    return options;
}

export const ENCRYPT = (text) => {
    if (text !== '' && text !== null && text !== undefined) {
        
       // return btoa(text);

        //return btoa(encodeURIComponent(text));
        return (text);
    } else {
        return '';
    }
}
export const DECRYPT = (text) => {
    if (text !== '' && text !== null && text !== undefined) {
        //return atob(text);
       // return atob(decodeURIComponent(text));
        return (text);
    } else {
        return '';
    }
}
export const UPLOAD_NAME_CONCAT = new Date().getTime();

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};


export const RELATIONAL_OPERATORS = [
    { label: '<', value: '<' },
    { label: '>', value: '>' },
    { label: '=', value: '=' },
    { label: '<=', value: '<=' },
    { label: '>=', value: '>=' },
];


export const DEFAULT_COMPANY_ID = '414FE8CA-61AA-4876-8FA5-22940150212E';

// A stored default page is only usable if it is actually a path. It arrives via
// localStorage.setItem, which stringifies whatever the login response carried —
// so a user with no default page configured leaves the literal string "null"
// (or "undefined") here, and <Redirect to="null"> navigates to a relative /null
// that matches no route at all.
const USABLE_PATH = (value) =>
    (typeof value === 'string' && value.charAt(0) === '/') ? value : null;

export const GET_DEFAULT_LANDING_PATH = () => {
    return USABLE_PATH(localStorage.getItem('defaultpage')) || '/dashboard';
}

// "/" is the public home page: a visitor who is not signed in gets the customer
// special order page, not a login form. The login form therefore has a path of
// its own, and everything staff-facing that used to send people to "/" — the
// signed-out redirect on a protected route, both logouts, the POS topbar — sends
// them to LOGIN_PATH instead. The special order page carries an "Employee login"
// link back to it (see SpecialOrderFooter.js).
//
// Neither of these is the page a staff member lands on after signing in: that
// stays GET_DEFAULT_LANDING_PATH above.
export const GUEST_HOME_PATH = '/pos/specialorder/details';
export const LOGIN_PATH = '/login';

// functionalRole 108 is the customer guest account, from the session saved at login.
export const IS_GUEST_SESSION = () => {
    try { return JSON.parse(DECRYPT(localStorage.getItem('employeeInfo'))).functionalRole == 108; }
    catch (e) { return false; }
};

// The page a live session belongs on, or null when there is no live session — no
// token, or an expired one. Mirrors authCheckState's own test.
//
// Read from localStorage rather than from the store because "/" decides where to
// send someone on its very first render, before componentDidMount's
// authCheckState has restored a stored session into redux. Waiting for redux
// would mean sending a signed-in employee to the customer page and only then
// discovering they had a session.
//
// This needs no special case for the '9999' guest account the customer pages sign
// visitors in as: its own configured default page IS the special order screen, so
// a guest lands exactly where GUEST_HOME_PATH would have sent them.
export const GET_SESSION_HOME_PATH = () => {
    if (!localStorage.getItem('token')) return null;
    if (new Date(localStorage.getItem('expirationDate')) <= new Date()) return null;

    return GET_DEFAULT_LANDING_PATH();
};

// Whether a real authentication has happened, for the login screens deciding
// whether to redirect away from themselves.
//
// `state.auth.token` cannot answer that on its own: the reducer seeds it with a
// placeholder string, so it is non-null before anyone has signed in. Gating on it
// made the login screens redirect off themselves on a cold load — to whatever
// `defaultpage` a previous session had left in localStorage, which is how opening
// the site a second time could land on the POS order screen. An authentication
// response is the real signal (userPosInfo starts null and is set from the
// response body by getUserPosInfo), and token going null on logout ends it.
export const IS_SIGNED_IN = (authState) =>
    authState.token !== null && Boolean(authState.userPosInfo);

// Where a user belongs once signed in: the default page named by their own
// authentication response (the values the user master offers are in
// DEFAULT_PAGE_OPTIONS in AddUser.js).
//
// For a user with none configured, the fallbacks in order: the copy of it in
// localStorage, in case only this response came back without one; then the
// service dashboard for the roles that have always been sent there (this rule
// used to live in SignInAr.js, which no longer gets the chance to apply it —
// App.js does the landing redirect now, before any login screen renders); then
// the plain dashboard.
export const GET_LANDING_PATH = (authResponse) => {
    const fromResponse = USABLE_PATH(authResponse && authResponse.defaultpage);
    if (fromResponse) return fromResponse;

    const stored = USABLE_PATH(localStorage.getItem('defaultpage'));
    if (stored) return stored;

    const role = localStorage.getItem('UserRole');
    if (role == "80" || role == "85" || role == "90") return '/dashboardservice';

    return '/dashboard';
};

export const REDIRECT_TO_URL = (url, props) => {
    setTimeout(() => {
        props.history.push(url);
    }, 3000)
}

export const DateFormetter = (date, format) => {
    const newDate = new Date(date);

    // var fromDate = new Date($("#Date_From").val());
    //                    var date = new Date(fromDate).toDateString("yyyy-MM-dd");
    let dd = newDate.getDate();
    let mm = newDate.getMonth() + 1; //January is 0!
    let yyyy = newDate.getFullYear();

    if (dd < 10) {
        dd = '0' + dd;
    }

    if (mm < 10) {
        mm = '0' + mm;
    }
    let shortDate = format === 'dd/MM/yyyy' ? dd + '/' + mm + '/' + yyyy : 'MM/dd/yyyy' ? mm + '/' + dd + '/' + yyyy : 'yyyy/MM/dd' ? yyyy + '/' + mm + '/' + dd : 'yyyy/dd/MM' ? yyyy + '/' + dd + '/' + mm : 'yyyy-mm-dd' ? yyyy + '-' + mm + '-' + dd : '';
    return shortDate;
};


export const DateTimeFormetter = (date, format) => {
    const newDate = new Date(date);

    let dd = newDate.getDate();
    let mm = newDate.getMonth() + 1;
    let yyyy = newDate.getFullYear();

    let Hours = newDate.getHours();
    let Minutes = newDate.getMinutes();

    if (dd < 10) {
        dd = '0' + dd;
    }

    if (mm < 10) {
        mm = '0' + mm;
    }
    let shortDate = format === 'yyyy-mm-dd' ? yyyy + '-' + mm + '-' + dd : '';
    return shortDate + ' ' + Hours + ':' + Minutes;
};




export const ResetDateFormat = date => {
    const newDate = new Date(date);
    return newDate;
}

export const MonthYearFormetter = date => {
    const newDate = new Date(date);

    // let dd = newDate.getDate();
    let mm = newDate.getMonth() + 1; //January is 0!
    let yyyy = newDate.getFullYear();

    // if (dd < 10) {
    //     dd = '0' + dd;
    // }

    if (mm < 10) {
        mm = '0' + mm;
    }

    let shortDate = mm + '/' + yyyy;
    return shortDate;
};


export const GetFutureDate = (date, days) => {

    // Convert 'days' to milliseconds
    const millies = 1000 * 60 * 60 * 24 * days;

    // Get the current date/time
    const todaysDate = new Date(date);

    // Get 'todaysDate' as Epoch Time, then add 'days' number of mSecs to it
    const futureMillies = todaysDate.getTime() + millies;

    // Use the Epoch time of the targeted future date to create
    //   a new Date object, and then return it.
    const targetedDate = new Date(futureMillies);
    return targetedDate;
}


export const removeString = (string, changeString = '') => {

    let replacingString = '';
    if (changeString === '') {
        replacingString = 'field_'
    }

    return string.replace(replacingString, "");
}


export const FieldValidations = [
    {
        label: 'Must be mininum 6 characters',
        value: 1,
        regex: '/[0-9a-zA-Z]{6,}/'
    },
    {
        label: 'Must be numbers',
        value: 2,
        regex: '^[0-9]+$'
    },
    {
        label: 'Must be alphanumeric',
        value: 3,
        regex: '^[a-zA-Z0-9]+$'
    }
]

export const FormSelections = [
    {
        label: 'Select Field Type',
        value: null
    },
    {
        label: 'Input Box',
        value: 1
    },
    {
        label: 'Select Box',
        value: 2
    },
    {
        label: 'Multi Select Box',
        value: 3
    },
    {
        label: 'Checkbox Button',
        value: 4
    },
    {
        label: 'Radio Button',
        value: 5
    },
    {
        label: 'Textarea Box',
        value: 6
    },
    {
        label: 'DateTimepicker',
        value: 7
    },
    {
        label: 'Datepicker',
        value: 8
    },
    {
        label: 'Containers',
        value: 9
    },
    {
        label: 'Switch Button',
        value: 10
    },
    {
        label: 'File',
        value: 11
    }


]



export const Levels = [
    { label: 'Employee', value: 1 },
    { label: 'Section', value: 2 },
    { label: 'Department', value: 3 },
    { label: 'Division', value: 4 },
    { label: 'Company', value: 5 },
    { label: 'Organization Unit', value: 6 }
]


export const SAPDATA = [
    { label: 'Create SES in SAP', value: 1 },
    { label: 'Create CAT in SAP', value: 2 },
    { label: 'Create JV in SAP FI', value: 3 }
];

export const TIMESHEET_TYPE = [
    { label: 'Positive TimeSheet', value: 1 },
    { label: 'Negative TimeSheet', value: 2 }
]

export const YEARSLIST = () => {

    let currentYear = new Date().getFullYear();

    let value = [];
    for (var i = 0; i < 15; i++) {
        value.push({ label: currentYear + 1, value: currentYear + 1 });
    }
    return value

}

export const arraySort = (arr, name) => {
    return arr.sort(function (a, b) {
        if (a[name] && b[name]) {
            let sortA = a[name];
            let sortB = b[name];
            if (sortA < sortB) {
                return -1;
            }
            else if (sortA > sortB) {
                return 1;
            }
        }
        return 0;
    });
}

export const ImplementationFor = {
    1: InputBox,
    2: SelectBox,
    3: MultiSelectBox,
    4: CheckBox,
    5: RadioBox,
    6: TextareaBox,
    7: DatePickerBox,
    8: DatePickerBox,
    9: ContainerBox,
    11: FileUploadBox
}



export const HASACCESS = (id) => {

    let defaultAccess = { addAccess: 0, deleteAccess: 0, editAccess: 0, pageAccess: 0, submenuPageAccess: 0 };

    let menuData = localStorage.getItem('menuStorage_GetAuthorization');
    if (menuData !== null) {
        menuData = DECRYPT(menuData);
        menuData = JSON.parse(menuData);
        let subMenu = [];
        let subMenuArray = [];
        if (menuData && menuData.length > 0) {
            let dynamicMenu = [];
            dynamicMenu = menuData.map((menu) => {
                if (menu.menuRights.length > 0) {
                    subMenu = menu.menuRights.map((sub) => {
                        subMenuArray.push(sub);
                        return sub;
                    });
                }
            });
        } else {
            return defaultAccess;
        }
        let access = [];
        if (subMenuArray && subMenuArray.length > 0) {
            access = subMenuArray.filter(menu => {
                return menu.subMenuId === id;
            }).reduce((_, el) => {
                return el;
            }, '')
        }
        if (access !== '') {
            return access;
        } else {
            return defaultAccess;
        }

    } else {
        return defaultAccess;
    }
}

export const TIME_DURATION = (ShiftStart, ShiftEnd) => {

    let currentDate = moment().format('DD-MMM-YYYY');
    let startTimes   = ShiftStart;//moment(ShiftStart).format('HH:mm');
    let endTimes     = ShiftEnd;//moment(ShiftEnd).format('HH:mm');
    const diffInMilliseconds = Math.abs(new Date(currentDate+' '+startTimes) - new Date(currentDate+' '+endTimes));
    
    var result = Math.floor(diffInMilliseconds/(1000*60*60)) + ":" + Math.floor(diffInMilliseconds/(1000*60))%60;
    
    return result;

    // let ShiftDuration = '';
    // var startTime = moment(ShiftStart, "HH:mm");
    // var endTime = moment(ShiftEnd, "HH:mm");
    // var duration = moment.duration(endTime.diff(startTime));
    // var hours = parseInt(duration.asHours());
    // var minutes = parseInt(duration.asMinutes()) % 60;
    // return ShiftDuration = hours + ':' + minutes;
}

// Great-circle distance between two lat/long points, in meters — used by the
// QR ordering location gate (LocationGate.js) to check a customer's device
// is within BRANCH_LOCATION.radiusMeters of the restaurant.
export const haversineDistanceMeters = (lat1, lon1, lat2, lon2) => {
    const EARTH_RADIUS_METERS = 6371000;
    const toRad = (deg) => (deg * Math.PI) / 180;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return EARTH_RADIUS_METERS * c;
};

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
}


// Excel Export Component
export const MasterListExcelExport = ({
    selectedItems = [],
    selectedColumns = [],
    columnOptions = [],
    standardOrder = [],
    processRow = null, // function to process each row if needed
    fileName = "Master_List.xlsx",
    buttonLabel = "Download List"
}) => {

    const downloadExcel = () => {
        if (!selectedItems || selectedItems.length === 0) return;

        // Filter standardOrder by selectedColumns
        const exportOrder = standardOrder.filter(field => selectedColumns.includes(field));

        // Map to headers using columnOptions
        const header = exportOrder.map(field =>
            (columnOptions.find(col => col.value === field) || {}).label || field
        );

        // Prepare rows
        const rows = selectedItems.map(emp =>
            exportOrder.map(field => {
                if (processRow) {
                    return processRow(emp, field);
                }
                return emp[field] || '';
            })
        );

        // Combine header and rows
        const worksheetData = [header, ...rows];

        // Create worksheet and workbook
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Set column widths for better spacing in Excel
        worksheet['!cols'] = header.map(() => ({ wch: 20 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Master");

        // Generate Excel file and trigger download
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, fileName);
    };

    return (
        <Button
            label={buttonLabel}
            icon="pi pi-download"
            className="p-button-secondary ml1"
            onClick={downloadExcel}
        />
    );
};